
export default {
  name: "elasticRouting",
  data() {
    return {
      transit: false,
    };
  },
  methods: {},
};
